/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

export const getCtasForTracking = (content: any) => {
  const elementsArray = [];

  if (content.cta1.text) {
    elementsArray.push({
      elementName: 'link',
      elementValue: content.cta1.text,
    });
  }
  if (content.cta2.text) {
    elementsArray.push({
      elementName: 'link',
      elementValue: content.cta2.text,
    });
  }
  return elementsArray;
};

export const addCtaClickTrackingEvent = (
  trackingService: TrackingServiceV2,
  ctaObject: any,
  style: string,
  pos: number,
) => {
  const dataLayerEvent = {
    eventInfo: {
      eventAction: setEventAction(ctaObject.link as string),
      eventName: 'minimalistic typographic teaser - click',
    },
    attributes: {
      componentName: 'minimalistic-typographic-teaser',
      label: ctaObject.text,
      targetURL: isFullUrl(ctaObject?.link as string),
      clickID: '',
      elementName: style === 'button' ? 'button' : 'text link',
      value: '',
      pos: '',
      relatedElements: [
        {
          elementName: 'link',
          elementValue: `${pos}-${camelCaseIt(ctaObject.text as string)}`,
        },
      ],
    },
  };

  trackingService.track({
    event: dataLayerEvent,
  });
};

export const getUrlExtension = (url: string) => {
  return url?.split(/[#?]/)[0].split('.')?.pop()?.trim();
};

export const setEventAction = (ctaUrl: string) => {
  const isExternalURL = (url: string): boolean => {
    if (url.startsWith('/')) return false;

    const hasProtocol = /^https?:\/\//i.test(url);
    const normalized = hasProtocol ? url : `https://${url}`;
    const parsed = new URL(normalized);

    if (!hasProtocol && parsed.hostname === window.location.hostname) {
      return false;
    }

    return parsed.origin !== window.location.origin;
  };

  if (getUrlExtension(ctaUrl) === 'pdf' || getUrlExtension(ctaUrl) === 'xlsx') return 'download';

  if (ctaUrl === '') return 'content';

  if (ctaUrl.includes('#')) return 'anchor';

  if (isExternalURL(ctaUrl)) return 'exit_link';

  return 'internal_link';
};

export const isFullUrl = (url: string): string => {
  const isLikelyExternal = /^[\w.-]+\.[a-z]{2,}(\/|$)/i.test(url);

  if (url.startsWith('http') || url.includes('#')) return url;

  if (isLikelyExternal) {
    return `https://${url}`;
  }

  return new URL(url, window.location.href).href;
};

export const camelCaseIt = (input: string) => {
  const regex = /\s+(\w)?/gi;

  const output = input.toLowerCase().replace(regex, function (match, letter: string) {
    return letter.toUpperCase();
  });
  return output;
};

export const addFootnoteTracking = (
  trackingService: TrackingServiceV2,
  target: HTMLAnchorElement,
) => {
  if (hasAnchorTag(target)) {
    const dataLayerEvent = {
      eventInfo: {
        eventAction: 'anchor',
        eventName: 'minimalistic typographic teaser - click on footnote',
      },
      attributes: {
        componentName: 'minimalistic-typographic-teaser',
        label: `${target.innerHTML}-${stringCleanUp(target.href)}`,
        targetURL: '',
        clickID: '',
        elementName: 'text link',
        value: '',
        pos: '',
      },
    };

    trackingService.track({
      event: dataLayerEvent,
    });
  }
};

export const stringCleanUp = (string: string) => {
  return string?.split('#')[1];
};

export const hasAnchorTag = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false;

  return !!target.closest('a');
};
